const profil = { t: 'Profil', name: 'profil', hint: { url: '/tire_profile' }}
export default profil